import { Controller } from "@hotwired/stimulus"

// Mostra l'anteprima di un'immagine appena selezionata, prima del submit.
export default class extends Controller {
  static targets = ["input", "preview"]

  show() {
    const file = this.inputTarget.files && this.inputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewTarget.src = e.target.result
      this.previewTarget.classList.remove("d-none")
    }
    reader.readAsDataURL(file)
  }
}
